require('../scss/style.scss');
require('./imports/skip-focus-link-fix.js');
require('./imports/navigation.js');
require('./imports/video.js');
require('./vue/main_app.js');

// require('./imports/jquery-2.1.4.min.js');
// import theta_carousel from './imports/theta-carousel.min.js'
// require('./../../../node_modules/owl.carousel/dist/assets/owl.carousel.css');
// require('./../../../somemodule/script.js');

import Blazy from 'blazy';
import owlCarousel from 'owl.carousel';
import Cookies from 'js-cookie';
import equalHeight from 'equal-height/dist/jquery.equalHeight.min.js';
import { TweenMax, TimelineMax } from "gsap";
require('../../includes/flexible-builder/flexible.js');
//import $ from 'jquery';
//import 'imports?jQuery=jquery!owl.carousel';



jQuery(document).ready(function ($) {
    $('.equal-height .equal').equalHeight({
        // groupByTop: false,
        // resizeTimeout: 20,
        // updateOnDOMReady: true,
        // updateOnDOMLoad: false
      })
    /**
     * Add to calendar
     */
    $('.addtocalendar .atcb-link').on('click', function (e) {
        e.preventDefault();
        $(this).addClass('showCal')
    })
    $('.addtocalendar .atcb-link').on('focusout', function (e) {
        $(this).removeClass('showCal')
    });

    const getUrlParameter = function (url, param) {
        var check = "" + param;
        if (url.search(check) >= 0) {
            return url.substring(url.search(check)).split('&')[0].split('=')[1];
        }
    };
    function hideNewsletterPopup() {
        $('.popup-newsletter').removeClass('show');
        var uri = window.location.toString();
        if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
        }
    }

    $(document).keyup(function (e) {
        if (e.keyCode === 27 && $('.popup-newsletter').hasClass('show')) hideNewsletterPopup()   // esc
    });

    $('.overlay-newsletter').on('click', function (e) {
        hideNewsletterPopup()
    })

    $('.button-newsletter a').on('click', function (e) {
        e.preventDefault();
        const newsletterType = getUrlParameter($(this).attr('href'), 'newsletter')
        if (newsletterType && $('#' + newsletterType)[0]) {
            $('#' + newsletterType).addClass('show')
        }
    });

    $('.button-newsletter').on('click', function (e) {
        e.preventDefault();
        const newsletterType = getUrlParameter($(this).attr('href'), 'newsletter')
        if (newsletterType && $('#' + newsletterType)[0]) {
            $('#' + newsletterType).addClass('show')
        }
    })

    var didScroll,
        lastScrollTop = 0,
        delta = 5,
        $header = $('header#masthead'),
        navbarHeight = $('header#masthead').outerHeight();

    $(window).scroll(function (event) {
        if (!$('html').hasClass('openNav')) {
            //console.log('scroll', didScroll);
            // console.log('navbarHeight', navbarHeight);

            didScroll = true;
        }
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(document).scrollTop();
        // Make sure they scroll more than delta
        //console.log('st', st, 'lastScrollTop: ', Math.abs(lastScrollTop - st) )

        if (Math.abs(lastScrollTop - st) <= delta)
            return;


        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            //console.log('scroll down')


            if( $('body').hasClass('nav-down') || !$('body').hasClass('nav-up')) {
                $header.removeClass('nav-down').addClass('nav-up');
                $('body').removeClass('nav-down').addClass('nav-up');
            }

        } else {
            // Scroll Up
            //if(st + $(window).height() < $(document).height()) {
            //}
            if( st < 30 && ($header.hasClass('nav-down') || $header.hasClass('nav-up'))){
                $header.removeClass('nav-up').removeClass('nav-down');
                $('body').removeClass('nav-up').removeClass('nav-down');
            }

            if(st >= 30 && $('body').hasClass('nav-up') ){
                $header.removeClass('nav-up').addClass('nav-down');
                $('body').removeClass('nav-up').addClass('nav-down');
            }
        }

        lastScrollTop = st;
    }

    /*     window.addEventListener( 'scroll', function()
        {
            //...
            if( wScrollCurrent <= 0 ) // scrolled to the very top; element sticks to the top
                element.style.top = '0px';

            else if( wScrollDiff > 0 ) // scrolled up; element slides in
                element.style.top = ( elTop > 0 ? 0 : elTop ) + 'px';

            else if( wScrollDiff < 0 ) // scrolled down
            {
                if( wScrollCurrent + wHeight >= dHeight - elHeight )  // scrolled to the very bottom; element slides in
                    element.style.top = ( ( elTop = wScrollCurrent + wHeight - dHeight ) < 0 ? elTop : 0 ) + 'px';

                else // scrolled down; element slides out
                    element.style.top = ( Math.abs( elTop ) > elHeight ? -elHeight : elTop ) + 'px';
            }
            //...
        }); */

    //add class when document is loded, and  if js is enabled
    $('html').addClass('document-ready js-enabled');
    $('html').removeClass('no-js');

    let prevIcon = '<svg width="20px" height="21px" viewBox="0 0 20 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Forside" transform="translate(-1040.000000, -520.000000)" fill="#FFFFFF"><g id="Group-5" transform="translate(1040.000000, 520.000000)"><polygon id="Shape" transform="translate(10.000000, 10.096154) scale(-1, 1) translate(-10.000000, -10.096154) " points="10 0 8.2375 1.77944712 15.2125 8.83413462 0 8.83413462 0 11.3581731 15.2125 11.3581731 8.2375 18.4128606 10 20.1923077 20 10.0961538"></polygon></g></g></g></svg>';
    let nextIcon = '<svg width="20px" height="21px" viewBox="0 0 20 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Forside" transform="translate(-1080.000000, -520.000000)" fill="#FFFFFF"><g id="Group-5" transform="translate(1040.000000, 520.000000)"><polygon id="Shape" points="50 0 48.2375 1.77944712 55.2125 8.83413462 40 8.83413462 40 11.3581731 55.2125 11.3581731 48.2375 18.4128606 50 20.1923077 60 10.0961538"></polygon></g></g></g></svg>';


    var bLazyImages = new Blazy({
        selector: ['.b-blur', '.b-lazy'],
        success: function (el) {
            var p = $(el).closest('.b-wrapper');
            $(p).removeClass('b-wrapper');
        },
        error: function (el, msg) {
            if (msg === 'missing') { /* Data-src is missing*/ } else if (msg === 'invalid') { /* Data-src is invalid */ }
        },
        breakpoints: [{
            width: 420, // max-width
            src: 'data-src-small'
        },
        {
            width: 768, // max-width
            src: 'data-src-medium'
        },
        ] // end of breakpoints
    });


    // Owl carousel trigger refresh for lazy load images after move image;

    if ($('.gallery-type-carousel').length) {
        $('.gallery-type-carousel').each(function (e) {
            var items = parseInt($(this).attr('data-cols'));
            $(this).owlCarousel({
                loop: false,
                margin: 0,
                nav: true,
                items: items,
                dots: false,
                fluidSpeed: 5,
                navText: ['‹', '›'],
                responsive: {
                    0: {
                        items: 1,
                    },
                    480: {
                        items: (items - 1) >= 2 ? (items - 1) : items,
                    },
                    767: {
                        items: items,
                    },
                },
                onTranslate: function () {
                    bLazyImages.revalidate();
                }
            });
        });
    }


    if ($('.front-carousel').length) {
        var timer = 6000;
        var dataTime = $('.front-carousel').attr('data-timer');
        if (dataTime && dataTime != '') {
            timer = Number(dataTime) * 1000;
        }
        $('.front-carousel').each(function (e) {
            $(this).owlCarousel({
                loop: true,
                margin: 0,
                nav: true,
                items: 1,
                dots: true,
                //autoplay: false,
                fluidSpeed: 5,
                autoplay: true,
                autoplayTimeout: timer,
                autoplayHoverPause: true,
                navText: [prevIcon, nextIcon],
                onChanged: function (e) {
                    var el = $(e.target).find('.carousel-texter')
                    var bg = $(e.target).find('.carouse-bg')
                    //console.log(el);
                    const tl = new TimelineMax({});
                    tl.set(el, {
                        //left: 50,
                        //scale: 0.9,
                        transformOrigin: '50% 50%',
                        ease: Back.easeInOut.config(0.3),
                    })
                    tl.set(bg, {
                        //scale: 1.02,
                        transformOrigin: '50% 50%',
                        ease: Back.easeInOut.config(0.3),
                    })

                    tl.to(el, 0.7, { opacity: 1, scale: 1 })
                    //.to(el, 0.8, { left: 0 }, "-=0.5")
                    //.to(bg, 1.5, { scale: 1 },  el);
                },
                onTranslate: function () {
                    bLazyImages.revalidate();
                }
            });
        });
    }

    /* ---------------------------------------
    | Add to link class .scroll-link
    | to make it scroll to ID container
    -----------------------------------------*/
    $(".scroll-link").click(function (event) {
        event.preventDefault();
        $('html,body').animate({ scrollTop: $(this.hash).offset().top - 50 }, 500);
    });


    /* ---------------------------------------
   | NAVIGATION
   -----------------------------------------*/
    var clicketNav = false;
    $('.menu-open, .toggle-menu-2').click(function (e) {
        if (!clicketNav) {
            clicketNav = true;
            $('body').toggleClass('openNav');
            $('.menu-open').toggleClass('active');
            $('.toggle-menu-2').toggleClass('active');
            $('#site-navigation').toggleClass('toggled');
            setTimeout(() => {
                clicketNav = false;
            }, 200);
        }
    });

    $(document).keyup(function (e) {
        if (e.keyCode == 27 && $('body').hasClass('openNav')) {
            $('.menu-open').trigger('click');
        }
    });
    $('.overlay-menu').on('click', () => {
        $('.menu-open').trigger('click');
    })

    /* ---------------------------------------
    | Popup windows for share link page links
    -----------------------------------------*/
    function popupCenter(url, title, w, h) {
        var left = (screen.width / 2) - (w / 2);
        var top = (screen.height / 2) - (h / 2);
        return window.open(url, title, 'toolbar=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    }

    $(document).on('click', '.content-share', function (e) {
        e.preventDefault();
        var url = $(this).attr('data-share_link'),
            name = $(this).attr('data-share_name'),
            height = $(this).attr('data-share_height'),
            width = $(this).attr('data-share_width');
        popupCenter(url, name, width, height);
    });

    // fix for tons of martin links

    let $liks_page = $('.list-page-childs');
    if ($liks_page.length) {
        $liks_page.find('.page_item ');
        let counter = 0;
        let arrs = [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35, 38, 41, 44, 47, 50];
        $liks_page.find('>.page_item ').each(function (index, item) {
            //console.log('index: '+index, 'ON: ' + $.inArray(index, arrs));

            if ($.inArray(index, arrs) !== -1) { // i know it is crap
                $(item).after('<span class="break-flex"></span>');
            }

        });

    }
    /* ---------------------------------------
    | Cookie Law info Cooki setup
    | @doc https://github.com/js-cookie/js-cookie/tree/v2.1.2#readme
    -----------------------------------------*/

    if ($('#cookie-law').length > 0) {
        let accepted = Cookies.get("cookie_law");
        if (accepted == "yes") {
            $('#cookie-law').remove();
        } else {
            let cookie_html = $('#cookie-element').html();
            $('#cookie-law.empty').replaceWith(cookie_html);
            $('#cookie-law').fadeIn();
        }
        $('#accept-cookie').on('click', function (e) {
            e.preventDefault();
            Cookies.set('cookie_law', 'yes', { expires: 365, path: '/' });
            $('#cookie-law').fadeOut();
        });
    }
    function enterAnimationStagger(el) {
        const tm = new TimelineMax({
        });
        tm.set(el, {
            scale: 0.9,
            opacity: -1,
            y: 200,
            transformOrigin: '50% 50%',
            ease: Back.easeInOut.config(0.3),
        });
        tm.staggerTo(el, 0.3, {
            opacity: 1,
            y: 0,
            onCompleteParams: ["{self}"],
            onComplete: function (ele) {
                TweenMax.to(ele.target, 0.3, { scale: 1 }, '+=0.5')
            }
        }, 0.1);
    }

    /* ---------------AJAX LOADING ELEMENTS ----------------------*/

    // FRONT PAGE NEWS

    let LoadFrontPageNewsDOM = document.getElementById("LoadFrontPageNews");

    if (document.body.contains(LoadFrontPageNewsDOM)) {
        // let equal = new equalheight('.blocks-frontpage-listed .row .col-sm-6');
        $.ajax({
            url: theme_data.theme_ajax,
            type: 'POST',
            data: {
                action: 'loadPostsArged',
                security: theme_data.nonce,
                shortinit: 'false',
                args: {
                    post_type: 'post',
                    load_views: 'loadViewPostFrontList',
                    posts_per_page: 4,
                }
            }
        }).done(function (data) {
            if (data.send) {
                $(LoadFrontPageNewsDOM).find('.inner-list').html(data.send);
                var el = $(document).find('#LoadFrontPageNews .block--article');
                enterAnimationStagger(el)

            } else {
                $(LoadFrontPageNewsDOM).find('.inner-list').html('<p>' + theme_data.strings.no_found + '</p>');
            }

        });
    }

    // FRONT PAGE EVENTS LIST

    let LoadFrontPageEventsDOM = document.getElementById("LoadFrontPageEvents");
    if (document.body.contains(LoadFrontPageEventsDOM)) {
        $.ajax({
            url: theme_data.theme_ajax,
            type: 'POST',
            data: {
                action: 'loadPostsArged',
                security: theme_data.nonce,
                shortinit: 'false',
                speicl: 'loadActiveEvents',
                args: {
                    post_type: 'arrangementer',
                    load_views: 'loadViewEventsFrontList',
                    posts_per_page: 4,
                }
            }
        }).done(function (data) {
            if (data.send) {
                $(LoadFrontPageEventsDOM).find('.inner-list').html(data.send);
                var el = $(document).find('#LoadFrontPageEvents .block--event');
                enterAnimationStagger(el)
            } else {
                $(LoadFrontPageEventsDOM).find('.inner-list').html('<p>' + theme_data.strings.no_events + '</p>');
            }

        });
    }

    // PAGE EMPLOYEES

    let PageConnectedEmployeesDOM = document.getElementById("PageConnectedEmployees");

    if (document.body.contains(PageConnectedEmployeesDOM)) {
        let ids = $(PageConnectedEmployeesDOM).attr('data-employees');
        $.ajax({
            url: theme_data.theme_ajax,
            type: 'POST',
            data: {
                action: 'loadPostsViewById',
                security: theme_data.nonce,
                shortinit: 'false',
                args: {
                    ids: ids,
                    load_views: 'loadViewEmployeesList',
                }
            }
        }).done(function (data) {
            if (data.send) {
                $(PageConnectedEmployeesDOM).find('.inner-list').html(data.send);
                var el = $(document).find('#PageConnectedEmployees .block--employee');
                enterAnimationStagger(el)
            } else {
                $(PageConnectedEmployeesDOM).find('.inner-list').html('');
            }

        });
    }

    let RelatedWidgetPostsDOM = document.getElementById("RelatedWidgetPosts");

    if (document.body.contains(RelatedWidgetPostsDOM)) {
        let cats_ids = $(RelatedWidgetPostsDOM).attr('data-categories');
        let post_id = $(RelatedWidgetPostsDOM).attr('data-postid');
        $.ajax({
            url: theme_data.theme_ajax,
            type: 'POST',
            data: {
                action: 'loadPostsArged',
                security: theme_data.nonce,
                shortinit: 'false',
                args: {
                    post__not_in: post_id,
                    posts_per_page: 3,
                    category__in: cats_ids,
                    load_views: 'loadViewRelatedPostsWidget',
                }
            }
        }).done(function (data) {
            if (data.send) {
                $(RelatedWidgetPostsDOM).find('.inner-list').html(data.send);
                var el = $(document).find('#RelatedWidgetPosts .block--article');
                enterAnimationStagger(el)
            } else {
                $(RelatedWidgetPostsDOM).find('.inner-list').html('');
            }

        });
    }

    let EventRelatedPostsDOM = document.getElementById("EventRelatedPosts");

    if (document.body.contains(EventRelatedPostsDOM)) {
        let post_id = $(EventRelatedPostsDOM).attr('data-eventid');
        $.ajax({
            url: theme_data.theme_ajax,
            type: 'POST',
            data: {
                action: 'loadPostsArged',
                security: theme_data.nonce,
                shortinit: 'false',
                current_post: post_id,
                speicl: 'loadEventRelatedPosts',
                args: {
                    posts_per_page: -1,
                    load_views: 'loadViewPostBlockList',
                }
            }
        }).done(function (data) {
            if (data.send) {
                $(EventRelatedPostsDOM).find('.inner-list').html(data.send);
            } else {
                $(EventRelatedPostsDOM).find('.inner-list').html('');
            }

        });
    }

    // WIDGET EVENT EVENTLIST

    let EventWidgetEventsDOM = document.getElementById("EventWidgetEvents");
    if (document.body.contains(EventWidgetEventsDOM)) {
        let post_id = $(EventWidgetEventsDOM).attr('data-postid');
        $.ajax({
            url: theme_data.theme_ajax,
            type: 'POST',
            data: {
                action: 'loadPostsArged',
                security: theme_data.nonce,
                shortinit: 'false',
                speicl: 'loadActiveEvents',
                args: {
                    post__not_in: post_id,
                    post_type: 'arrangementer',
                    load_views: 'loadViewEventsFrontList',
                    posts_per_page: 3,
                }
            }
        }).done(function (data) {
            if (data.send) {
                $(EventWidgetEventsDOM).find('.inner-list').html(data.send);
            } else {
                $(EventWidgetEventsDOM).find('.inner-list').html('');
            }

        });
    }


    if ($('#content .post-links .block-link').length) {
        enterAnimationStagger($('#content .post-links .block-link'));
    }

    var newCarouselEmpl = $('#connected-employees .connected-employees');
    if (newCarouselEmpl.length) {
        var onEmpCount = newCarouselEmpl.attr('data-count');
        newCarouselEmpl.css({
            opacity: 0
        });
        newCarouselEmpl.delay(500).animate({
            opacity: 1
        }, 500);

        newCarouselEmpl.theta_carousel({
            "filter": ".item",
            "selectedIndex": (onEmpCount % 2 !== 0) ? Math.floor(onEmpCount / 2) : Math.floor(onEmpCount / 2),
            "distance": 125,
            "designedForWidth": (window.innerWidth > 780) ? 1920 : 1400,
            "designedForHeight": (window.innerWidth > 780) ? 925 : 700,
            "numberOfElementsToDisplayRight": (window.innerWidth > 1024) ? 6 : 4,
            "numberOfElementsToDisplayLeft": (window.innerWidth > 1024) ? 6 : 4,
            "scaleZ": 1,
            "mousewheelEnabled": false,
            "distanceInFallbackMode": 50,
            "path": {
                "settings": {
                    "shiftY": 201,
                    "shiftZ": 440,
                    "rotationAngleZY": (window.innerWidth > 780) ? -21 : -26,
                    "wideness": 800
                },
                "type": "parabola"
            },
            "shadow": false,
            "shadowBlurRadius": 0,
            sensitivity: 0.4,
            "shadowSpreadRadius": 0,
            fadeAway: false,
            fadeAwayBezierPoints: {
                p1: {
                    x: 0,
                    y: 100
                },
                p2: {
                    x: 96,
                    y: 96
                },
                p3: {
                    x: 95,
                    y: 99
                },
                p4: {
                    x: 100,
                    y: 0
                }
            },
            "popoutSelected": true,
            "popoutSelectedShiftY": -23,
            "popoutSelectedShiftZ": 63,
        });

        var employeeNamePos = $('.connected-employees-details .name-pos');
        var employeeNav = $('.connected-employees-details nav');
        var employeeMore = $('.connected-employees-details .more div');
        var employeeDetails = $('.connected-employees-details');


        /*
           var connectedEmployees = $('.connected-employees');
           var emplOwl = connectedEmployees.owlCarousel({
               center: true,
               items: 5,//onEmpCount,
               startPosition: (onEmpCount % 2 !== 0) ? Math.floor(onEmpCount/2) : Math.floor(onEmpCount/2),
               loop:false,
               margin:0,
               dots: false,
               nav: false,
               mouseDrag: false,
               onInitialized: function(e) {
                   prepareEmplItems(e);
               },
               responsive: {
                   0: {
                       items: 3,
                   },
                   480: {
                       items: 5,
                   },
               },
           });
           */
        $('#empl-car-next').on('click', function () {
            newCarouselEmpl.theta_carousel('moveForward');
        });
        $('#empl-car-prev').on('click', function () {
            newCarouselEmpl.theta_carousel('moveBack');
        });
        employeeNav.on('mouseenter', function (e) {
            if (e.target.tagName.toLowerCase() === 'a' || e.target.tagName.toLowerCase() === 'span') {
                $(this).addClass('hover');
            }
        });
        employeeNav.on('mouseleave', function (e) {
            if (e.target.tagName.toLowerCase() === 'a' || e.target.tagName.toLowerCase() === 'span') {
                $(this).removeClass('hover');
            }
        });
        $(newCarouselEmpl).on('change', function (e, data) {
            prepareEmplItems(data)
        });
    }

    function prepareEmplItems(e) {
        //connectedEmployees.find('.owl-item').attr('class', (i, c) => c.replace(/(^|\s)left-\S+/g, '').replace(/(^|\s)right-\S+/g, '') );
        employeeNamePos.removeClass('active');
        employeeMore.removeClass('active');
        var n = e.index + 1;
        // var cur = connectedEmployees.find('.owl-item:nth-child('+n+')');
        var r = 1;
        var l = 1;
        employeeDetails.find('.name-pos:nth-child(' + (n + 2) + ')').addClass('active');
        employeeDetails.find('.more div:nth-child(' + (n) + ')').addClass('active');
        /*         cur.nextAll().each(function() {
                    $(this).addClass('right-'+r);
                    r ++;
                });
                cur.prevAll().each(function() {
                    $(this).addClass('left-'+l);
                    l ++;
                }) */
    }
    /*     emplOwl.on('translate.owl.carousel', function(e) {
            prepareEmplItems(e);
        }); */


    /* ---------------------------------------
    | Tabs on single memberiade
    -----------------------------------------*/
    $('.tab-container .tabs-list a').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            return;
        } else {
            let targetTab = $(this).attr('data-target');
            // console.log(targetTab);
            $(this).parent().parent().find('a').removeClass('active');
            $(this).addClass('active');

            $(this).parent().parent().parent().find('li.tab').removeClass('active');
            $(this).parent().parent().parent().find('li#' + targetTab).addClass('active');
        }
    })



    if (theme_data.newsletter_form_id) {
        var newsletterId = theme_data.newsletter_form_id;
        var cross = '<svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square"><g id="Påmelding-nyhetsbrev" transform="translate(-924.000000, -231.000000)" stroke="#343638" stroke-width="2"><g id="Group" transform="translate(865.000000, 230.000000)"><g id="Group-2" transform="translate(60.000000, 2.000000)"><path d="M0.714285714,0.714285714 L19.2857143,19.2857143" id="Line"></path><path d="M0.714285714,0.714285714 L19.2857143,19.2857143" id="Line" transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "></path></g></g></g></g></svg>';

        var close_btn = '<span class=\"close newsletter-close\">' + theme_data.strings.close + ' ' + cross + '</span>';
        var ajaxi = false;
        var preloader = '<div class=\"sk-cube-grid\"><div class=\"sk-cube sk-cube1\"></div><div class=\"sk-cube sk-cube2\"></div><div class=\"sk-cube sk-cube3\"></div><div class=\"sk-cube sk-cube4\"></div><div class=\"sk-cube sk-cube5\"></div><div class=\"sk-cube sk-cube6\"></div><div class=\"sk-cube sk-cube7\"></div><div class=\"sk-cube sk-cube8\"></div><div class=\"sk-cube sk-cube9\"></div></div>';

        $(document).on('click', '.newsletter-close', function () {
            $('#gf_button_form_container_' + newsletterId).fadeOut().html('');
        });
        $(document).on('click', '.form-delaer-popup', function (e) {
            if (!$(this).find('.gform_wrapper').length) {
                $('#gf_button_form_container_' + newsletterId).fadeOut().html('');
            }
        });

        $('.callNewsletter').click(function (e) {
            e.preventDefault();
            if ($('body').hasClass('openNav')) {
                $('.menu-open').trigger('click');
            }
            var button = $(this);
            if (ajaxi) return;
            ajaxi = true;
            $('#gf_button_form_container_' + newsletterId).html(preloader).fadeIn()
            $.get(theme_data.ajaxurl + '?action=gf_button_get_form&form_id=' + newsletterId, function (response) {
                $('#gf_button_form_container_' + newsletterId).html(response);
                $('#gf_button_form_container_' + newsletterId + ' .gform_wrapper').append(close_btn);
                //button.remove();
                ajaxi = false;
                if (window['gformInitDatepicker']) { gformInitDatepicker(); }
            });
        });
    }

    /* ---------------------------------------
    | collapsed
    -----------------------------------------*/
    $('.collapsed-list .collapse-header').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).next().slideToggle().toggleClass('collapsed');
    })

});



// WEBPACK FOOTER //
// ./src/js/scripts.js